import { render, staticRenderFns } from "./FunnelsItemTypeA.vue?vue&type=template&id=473cbe68"
import script from "./FunnelsItemTypeA.vue?vue&type=script&lang=js"
export * from "./FunnelsItemTypeA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports